import { findBracket } from '.';

export const partBPremium = 202.9;

export const partBDeductible = 283.0;

export const partADeductible = 1736.0;

export const dailyHospital61To90 = 434.0;

export const dailyHospitalLifetimeReserve = 868.0;

export const skilledNursingDays21To100 = 217.0;

// If User Part D IRMAA premium is equal to the mapped value of the largest key that their income is greater than.
// 2026 Part B base is 202.90
const individualBracketToPartDPremium = [
  {
    id: 1,
    amount: '$109,000 or less',
    lower: 0,
    upper: 109000,
    partDPremium: 0,
    partBPremium: 0,
    monthlyPayment: 202.9,
  },
  {
    id: 2,
    amount: 'above $109,000 up to $137,000',
    lower: 109001,
    upper: 137000,
    partDPremium: 14.5,
    partBPremium: 81.2,
    monthlyPayment: 284.0,
  },
  {
    id: 3,
    amount: 'above $137,000 up to $171,000',
    lower: 137001,
    upper: 171000,
    partDPremium: 37.5,
    partBPremium: 202.9,
    monthlyPayment: 405.0,
  },
  {
    id: 4,
    amount: 'above $171,000 up to $205,000',
    lower: 171001,
    upper: 205000,
    partDPremium: 60.4,
    partBPremium: 324.6,
    monthlyPayment: 527.5,
  },
  {
    id: 5,
    amount: 'above $205,000 and less than $500,000',
    lower: 200000,
    upper: 500000,
    partDPremium: 83.3,
    partBPremium: 446.3,
    monthlyPayment: 649.2,
  },
  {
    id: 6,
    amount: '$500,000 or above',
    lower: 500001,
    upper: 10000000,
    partDPremium: 91.0,
    partBPremium: 487.0,
    monthlyPayment: 689.9,
  },
];

const jointBracketToPartDPremium = [
  {
    id: 1,
    amount: '$218,000 or less',
    lower: 0,
    upper: 218000,
    partDPremium: individualBracketToPartDPremium[0].partDPremium,
    partBPremium: individualBracketToPartDPremium[0].partBPremium,
    monthlyPayment: individualBracketToPartDPremium[0].monthlyPayment,
  },
  {
    id: 2,
    amount: 'above $218,000 up to $274,000',
    lower: 218001,
    upper: 274000,
    partDPremium: individualBracketToPartDPremium[1].partDPremium,
    partBPremium: individualBracketToPartDPremium[1].partBPremium,
    monthlyPayment: individualBracketToPartDPremium[1].monthlyPayment,
  },
  {
    id: 3,
    amount: 'above $274,000 up to $342,000',
    lower: 274001,
    upper: 342000,
    partDPremium: individualBracketToPartDPremium[2].partDPremium,
    partBPremium: individualBracketToPartDPremium[2].partBPremium,
    monthlyPayment: individualBracketToPartDPremium[2].monthlyPayment,
  },
  {
    id: 4,
    amount: 'above $342,000 up to $410,000',
    lower: 342001,
    upper: 410000,
    partDPremium: individualBracketToPartDPremium[3].partDPremium,
    partBPremium: individualBracketToPartDPremium[3].partBPremium,
    monthlyPayment: individualBracketToPartDPremium[3].monthlyPayment,
  },
  {
    id: 5,
    amount: 'above $410,000 up to $750,000',
    lower: 410000,
    upper: 750000,
    partDPremium: individualBracketToPartDPremium[4].partDPremium,
    partBPremium: individualBracketToPartDPremium[4].partBPremium,
    monthlyPayment: individualBracketToPartDPremium[4].monthlyPayment,
  },
  {
    id: 6,
    amount: '$750,000 or above',
    lower: 750001,
    upper: 10000000,
    partDPremium: individualBracketToPartDPremium[5].partDPremium,
    partBPremium: individualBracketToPartDPremium[5].partBPremium,
    monthlyPayment: individualBracketToPartDPremium[4].monthlyPayment,
  },
];

type Info = {
  partBPremium: string;
  partDPremium: string;
};

export const irmaaBracket = {
  individualBracket: individualBracketToPartDPremium,
  jointBracket: jointBracketToPartDPremium,
};

export default function getIRMAAInfo(user): string[] {
  if (user.profile.filed_individual_taxes === null) {
    return ['User is missing tax filing status'];
  }

  if (!user.profile.income_brackets) {
    return ['User is missing income bracket info'];
  }
  const userBracket = findBracket(user.profile.income_brackets, user.profile.filed_individual_taxes);

  if (!userBracket) return ['Failed to calculate IRMAA.'];

  const bracketToPremium = user.profile.filed_individual_taxes
    ? individualBracketToPartDPremium
    : jointBracketToPartDPremium;

  const premium = bracketToPremium.find(
    (bracket) =>
      (bracket.lower === userBracket.lower_bound || bracket.lower - 1 === userBracket.lower_bound) &&
      (bracket.upper === userBracket.upper_bound || bracket.upper + 1 === userBracket.upper_bound)
  );

  if (!premium) return ['Failed to calculate IRMAA.'];

  const { partBPremium, partDPremium } = premium;

  const info: Info = {
    partBPremium: `Part B: $${partBPremium.toFixed(2)}`,
    partDPremium: `Part D: $${partDPremium.toFixed(2)}`,
  };

  return Object.keys(info).reduce((acc: string[], curr: string) => {
    acc.push(info[curr]);
    return acc;
  }, []);
}
